import entities from 'src/config/entities'
import i18n from 'src/i18n'

const types = {
  SET_FILTER_PRESETS: 'SET_FILTER_PRESETS',
  PATCH_DEFAULT_FILTERS: 'PATCH_DEFAULT_FILTERS',
  ADD_FILTER_PRESET: 'ADD_FILTER_PRESET',
  REMOVE_FILTER_PRESET: 'REMOVE_FILTER_PRESET',
  SET_PRESET_INDEX: 'SET_PRESET_INDEX',
}

let defaultFilters = [
  {
    name: i18n.t('job.menu.all'),
    persistent: true,
    entity: entities.JOB,
    filters: []
  },
  {
    name: i18n.t('job.menu.active'),
    entity: entities.JOB,
    persistent: true,
    filters: [{
      'field': {
        'field': 'status',
        'label': 'Status',
        'type': 'multiselect',
        'typeahead': null,
        'options': {
          'draft': 'Concept',
          'active': 'Actief',
          'pause': 'Pauze',
          'finished': 'Afgerond',
          'check': 'Controle',
          'rejected': 'Afgewezen',
          'order': 'Bestelling'
        }
      }, 'operator': 'IS', 'values': 'active', 'label': 'Status', 'selected': true, 'valuesLabel': 'Actief'
    }]
  },
  {
    name: i18n.t('job.menu.paused'),
    entity: entities.JOB,
    persistent: true,
    filters: [{
      'field': {
        'field': 'status',
        'label': 'Status',
        'type': 'multiselect',
        'typeahead': null,
        'options': {
          'draft': 'Concept',
          'active': 'Actief',
          'pause': 'Pauze',
          'finished': 'Afgerond',
          'check': 'Controle',
          'rejected': 'Afgewezen',
          'order': 'Bestelling'
        }
      },
      'operator': 'IS',
      'values': 'pause',
      'min': '',
      'max': '',
      'label': 'Status',
      'selected': true,
      'valuesLabel': 'Pauze'
    }]
  }
]

let defaultFilterUpdates = [
  {
    'name': i18n.t('job.menu.check'),
    persistent: true,
    'entity': 'job',
    'filters': [{
      'field': {
        'field': 'status',
        'label': 'Status',
        'type': 'multiselect',
        'typeahead': null,
        'options': {
          'draft': 'Concept',
          'active': 'Actief',
          'pause': 'Pauze',
          'finished': 'Afgerond',
          'check': 'Controle',
          'rejected': 'Afgewezen',
          'order': 'Bestelling'
        }
      },
      'operator': 'IN',
      'values': ['check'],
      'min': '',
      'max': '',
      'label': 'Status',
      'selected': true,
      'valuesLabel': ['Controle', 'Bestelling']
    }]
  },
  {
    'name': i18n.t('job.menu.admins'),
    persistent: true,
    'entity': 'job',
    'filters': [{
      'field': {
        'field': 'admins',
        'label': 'Posted by Admins',
        'options': null,
        'type': "boolean",
        'typeahead': null
      },
      'operator': 'IS',
      'values': [true],
      'min': '',
      'max': '',
      'label': 'Posted by Admins',
      'selected': true,
    }]
  },
  {
    'name': i18n.t('job.menu.notAdmins'),
    persistent: true,
    'entity': 'job',
    'filters': [{
      'field': {
        'field': 'not_admins',
        'label': 'Posted by Users',
        'options': null,
        'type': "boolean",
        'typeahead': null
      },
      'operator': 'IS',
      'values': [true],
      'min': '',
      'max': '',
      'label': 'Posted by Users',
      'selected': true,
    }]
  },
  {
    'name': i18n.t('job.menu.automatic'),
    persistent: true,
    'entity': 'job',
    'filters': [{
      'field': {
        'field': 'automatic',
        'label': 'Posted automatically (API)',
        'options': null,
        'type': "boolean",
        'typeahead': null
      },
      'operator': 'IS',
      'values': [true],
      'min': '',
      'max': '',
      'label': 'Posted automatically (API)',
      'selected': true,
    }]
  },
  {
    name: i18n.t('ecommerce.menu.orders'),
    persistent: true,
    entity: entities.ORDER,
    filters: []
  },
  {
    'name': 'To check',
    'entity': 'order',
    'filters': [{
      'field': {
        'field': 'status',
        'label': 'messages.filters.order.field.status',
        'type': 'multiselect',
        'typeahead': null,
        'options': {
          'check': 'messages.filters.order.status.check',
          'payment-provider': 'messages.filters.order.status.payment-provider',
          'rejected': 'messages.filters.order.status.rejected',
          'cart': 'messages.filters.order.status.cart',
          'expired': 'messages.filters.order.status.expired',
          'success': 'messages.filters.order.status.success'
        }
      },
      'operator': 'IS',
      'values': 'check',
      'min': '',
      'max': '',
      'label': 'messages.filters.order.field.status',
      'selected': true,
      'valuesLabel': 'messages.filters.order.status.check'
    }]
  }
]
const state = {
  filterPresets: [...defaultFilters]
}

const mutations = {
  [types.SET_FILTER_PRESETS]: (state, value) => {
    state.filterPresets = value
  },
  [types.SET_PRESET_INDEX]: (state, value) => {
    state.activeFilterPresetIndex = value
  },
  [types.PATCH_DEFAULT_FILTERS]: (state) => {
    defaultFilterUpdates.forEach(filter => {
      let existing = state.filterPresets.find(p => p.name === filter.name && p.entity === filter.entity)
      if (!existing) {
        state.filterPresets.push(filter)
      }
    })
  },
  [types.ADD_FILTER_PRESET]: (state, value) => {
    state.filterPresets.push(value)
  },
  [types.REMOVE_FILTER_PRESET]: (state, value) => {
    let index = state.filterPresets.findIndex(p => p.name === value.name && p.entity === value.entity)
    if (index !== -1) {
      state.filterPresets.splice(index, 1)
    }
  }
}

const actions = {}
const getters = {}

export default {
  namespaced: true,
  types,
  state,
  mutations,
  actions,
  getters
}
